import { useAuthenticator } from "@aws-amplify/ui-react";
import { useQuery } from "@tanstack/react-query";
import { useReverseUserId, fetchWithAlert } from "functions";
import { PersonInformation } from "types/personInformationType";

const fetchPersonInfomation = async (
  personCd: string,
): Promise<PersonInformation> => {
  return await fetchWithAlert(
    `${process.env.REACT_APP_AWS_CLOUDFRONT_URL}/header`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        person_cd: personCd,
      }),
    },
  );
};

export const useQueryPersonInfomation = () => {
  const { user } = useAuthenticator((context) => [context.authStatus]);
  const id = useReverseUserId(user);

  return useQuery({
    queryKey: [`personInfomation${id}`],
    queryFn: () => fetchPersonInfomation(user.username),
    staleTime: 60 * 60 * 1000, // NOTE: 1 hour
    enabled: !!user,
  });
};
